import type { ReactNode } from "react"

import { Button } from "./Button"
import { ComDica } from "./ComDica"
import * as Icones from "./Icones"
import { Skeleton } from "./Skeleton"
import { BOTAO_BRANCO, MAIUSCULA, RECUSA } from "../lib/classes"
import { cn } from "../lib/cn"

export function Bloco({
  titulo,
  dica,
  aoLado,
  acoes,
  children,
}: {
  titulo: string
  dica?: string
  aoLado?: ReactNode
  acoes?: ReactNode
  children: ReactNode
}) {
  return (
    <section data-slot="bloco-do-athus" aria-label={titulo} className="flex flex-col gap-2 px-6 py-6">
      <header className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap items-center gap-3">
          <h2 data-slot="titulo-do-bloco" className="m-0 flex items-center gap-1.5 text-sm leading-none font-semibold text-(--tinta) uppercase">
            {titulo}
            {dica !== undefined && <ComDica dica={dica} />}
          </h2>
          {aoLado}
        </div>
        {acoes !== undefined && <div className="flex flex-wrap items-center gap-2">{acoes}</div>}
      </header>
      <div data-slot="conteudo-do-bloco" className="flex flex-col gap-4 px-5">
        {children}
      </div>
    </section>
  )
}

export function Parte({ titulo, dica, acoes, children }: { titulo: string; dica?: string; acoes?: ReactNode; children: ReactNode }) {
  return (
    <div data-slot="parte-do-bloco" className="flex flex-col gap-2.5">
      <div className="flex min-h-8 flex-wrap items-center justify-between gap-2">
        <h3 data-slot="titulo-da-parte" className="m-0 flex items-center gap-1.5 text-sm font-semibold text-(--tinta)">
          {titulo}
          {dica !== undefined && <ComDica dica={dica} />}
        </h3>
        {acoes !== undefined && <div className="flex flex-wrap items-center gap-2">{acoes}</div>}
      </div>
      {children}
    </div>
  )
}

export function CarregandoNaSecao() {
  return (
    <div aria-busy="true" className="flex flex-col gap-3">
      <Skeleton className="h-10 w-1/2" />
      {[0, 1, 2].map((linha) => (
        <Skeleton key={linha} className="h-9 w-full" />
      ))}
    </div>
  )
}

export function FalhaNaSecao({ mensagem, aoTentar }: { mensagem: string; aoTentar: () => void }) {
  return (
    <div className="flex flex-1 flex-wrap items-center gap-3">
      <p role="alert" className={cn(RECUSA, "m-0 min-w-0 flex-1 basis-64", MAIUSCULA)}>
        {mensagem}
      </p>
      <Button type="button" variant="outline" size="sm" className={BOTAO_BRANCO} onClick={aoTentar}>
        <Icones.Recalcular />
        Tentar de novo
      </Button>
    </div>
  )
}
